// export const API_HOST = 'http://localhost:4000/api'
export const API_HOST = 'https://api.harddisk.cloud/api'

export const API_VER  = '/v1'